import * as React from 'react';
import Card from '../Card/Card';
import { numberWithCommas } from '../../utils/utils';

const goToTickets = () => 'link/';

function NewHeaderWidget({
  timePeriod,
  title,
  className,
  subtitle,
  count,
  percent,
  isLoading,
  onClick,
  style,
  color,
  ...otherProps
}) {
  return (
    <Card
      className={['NewHeaderWidget', color, className]
        .filter((f) => !!f)
        .join(' ')}
      onClick={timePeriod === '90days' ? goToTickets : null}
      title={title}
      isLoading={isLoading}
      subtitle={subtitle}
      style={style}
      {...otherProps}>
      <div className="count">
        {(timePeriod === '90days') & !!count
          ? numberWithCommas(count)
          : `${percent || 0}%`}
      </div>
    </Card>
  );
}

export default NewHeaderWidget;
